import { Injectable } from '@angular/core';
import { ThemeService } from '@thx/services/angular/themes';
import { ChatbotThemes } from '@thx/enums';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IThemeManifest} from "../interfaces/theme-manifest.interface";
import {convict} from "../config/convict-env.config";

@Injectable({ providedIn: 'root' })
export class ChatbotThemeService extends ThemeService<ChatbotThemes> {
  _currentTheme = ChatbotThemes.ETURIA;
  B2B_CDN_URL = convict.b2bCdnUrl;
  BASE_ASSETS_URL = `${this.B2B_CDN_URL}/libs/chatbot-widget`;

  constructor(private readonly _http: HttpClient) {
    super();
  }

  override loadCss(themeToLoad: ChatbotThemes): void {
    if (this._styleElement && this.currentThemeStr) {
      this.removeUnusedTheme(this.currentThemeStr);
    }


    this._getManifest().subscribe((manifest: IThemeManifest) => {
      const cssFile = manifest.themes[themeToLoad];
      const cssUrl = `${this.BASE_ASSETS_URL}/${cssFile}`;
      this._styleElement = this._renderer2.createElement('link');
      this._renderer2.setProperty(this._styleElement, 'rel', 'stylesheet');
      this._renderer2.setProperty(this._styleElement, 'href', cssUrl);
      this._renderer2.appendChild(this._document.head, this._styleElement);
      this._currentTheme = themeToLoad;
    });
  }

  private _getManifest(): Observable<IThemeManifest> {
    const manifestUrl = `${this.BASE_ASSETS_URL}/theme-manifest.json`;
    return this._http.get<IThemeManifest>(manifestUrl);
  }
}
